import { render, staticRenderFns } from "./AlertDialogComments.vue?vue&type=template&id=f2acf6de&"
import script from "./AlertDialogComments.vue?vue&type=script&lang=js&"
export * from "./AlertDialogComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports